export default Object.freeze({
	RECURRING_PAYMENTS_ORDER_MANAGEMENT: '정기결제(배송) 관리',
	RECURRING_PAYMENT: '정기결제',

	PAGE_DESCRIPTION_1: '고객이 신청한 정기결제(배송) 내역을 관리할 수 있습니다',
	PAGE_DESCRIPTION_2: '정기결제(배송) 주문은 주문관리에서 정기결제 건으로 구분되며, ' +
		'고객이 신청한 정기배송일 2일 전 주문서 생성 후 자동 결제 됩니다.',
	PAGE_DESCRIPTION_ABOUT_TERMS: '정기결제(배송) 사용 시 반드시 주문서 페이지에 이용약관을 설정하시기 바랍니다.',
	GO_TO_TERMS_OF_USE: '이용약관 바로가기>',

	SEARCH_KEYWORD_PLACEHOLDER_TEXT: '복수 상품 검색이 가능합니다. (Enter 또는 \',\'로 구분)',

	DELIVERY_CYCLE: '배송주기',
	DELIVERY_DATE: '배송일',

	//그리드
	CLOSE_RECURRING_PAYMENTS: '정기결제(배송) 해지',
	RECURRING_PAYMENT_NO: '신청번호',
	REGISTER_YMD: '신청일',
	REGISTRANT_NAME: '신청자',
	SELLING_PRICE: '판매가',
	DISCOUNT_ON_RECURRING_PAYMENTS_IMMEDIATELY: '정기결제(배송) 즉시할인',
	DISCOUNT_PRICE: '할인 적용가',
	DELIVERY_DATE_AND_ROUND: '배송 예정일(회차)',
	RECURRING_PAYMENT_STATUS: '이용상태',
	CLOSE_YMD: '해지일',
	CLOSE_INFO: '해지 상세정보',
	DELIVERY_ROUND: '회차',

	ACTIVE: '이용중',
	SYSTEM_CLOSED: '시스템 해지',
	ADMIN_CLOSED: '관리자 해지',
	USER_CLOSED: '해지',

	// 해지 상세정보 팝업
	CLOSE_REASON: '해지 사유',
	CLOSE_REASON_DETAIL: '상세 사유',

	// 얼럿
	NO_SELECTED_PRODUCT_ALERT_TEXT: '상품을 선택해주세요',
	CLOSE_SUCCESS_ALERT_TEXT: '해지되었습니다.', // 기획 X


	// 컨펌
	CLOSE_RECURRING_PAYMENTS_CONFIRM_TEXT: '선택하신 신청 건 해지 시 해당 상품의 정기결제(배송)이 모두 중단 됩니다.' +
 		'\n선택하신 신청건을 모두 해지 하시겠습니까?',

})